// extracted by mini-css-extract-plugin
module.exports = {"leadersHeadingDiv":"leader-heading_leadersHeadingDiv__Kq1JU","leaderSubHeading":"leader-heading_leaderSubHeading__9a_Um"};